import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
import { brand } from '../config/branding.js';
import { cn } from '../utils/cn.js';
const SIZE = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-4xl',
};
/**
 * The TrueCare crest — inline SVG so it ships with the tsc-built package (no
 * bundler asset pipeline) and scales with the wordmark. Vector-identical to
 * `logo-icon.svg` in the brand kit and the marketing favicon. Self-contained
 * fill colours (forest disc + cream pinwheel) so it reads on any light ground;
 * it does NOT follow `currentColor`, keeping the mark on-brand even when the
 * wordmark flips to cream on a dark surface.
 */
function Crest() {
    return (_jsxs("svg", { viewBox: "0 0 100 100", className: "h-[1.35em] w-[1.35em] shrink-0 self-center", role: "img", "aria-hidden": "true", children: [_jsx("circle", { cx: "50", cy: "50", r: "50", fill: "#29473A" }), _jsxs("g", { fill: "#F7F5EF", children: [_jsx("ellipse", { cx: "50", cy: "30", rx: "11", ry: "17", transform: "rotate(28 50 50)" }), _jsx("ellipse", { cx: "50", cy: "30", rx: "11", ry: "17", transform: "rotate(118 50 50)" }), _jsx("ellipse", { cx: "50", cy: "30", rx: "11", ry: "17", transform: "rotate(208 50 50)" }), _jsx("ellipse", { cx: "50", cy: "30", rx: "11", ry: "17", transform: "rotate(298 50 50)" })] })] }));
}
/**
 * Brand lockup — crest mark + Georgia-italic "TrueCare" + Source-Sans
 * "Partners" per the Q5 mockup. The wordmark colour switches from forest
 * (default) to cream on a dark background (pass `className="text-cream"`);
 * the crest keeps its own colours regardless.
 *
 * Single source of truth for the lockup across all portal surfaces
 * (portal / admin). The marketing site uses the raster horizontal lockup
 * for its header/footer; this component covers everywhere else.
 */
export function Brand({ size = 'md', short, noMark, className, ...rest }) {
    return (_jsxs("span", { className: cn('inline-flex items-center gap-[0.4em] text-forest leading-none', SIZE[size], className), "aria-label": brand.productName, ...rest, children: [!noMark && _jsx(Crest, {}), _jsxs("span", { className: "inline-flex items-baseline gap-1.5", children: [_jsxs("span", { className: "font-logo italic", children: ["TrueCare", _jsx("sup", { className: "font-body not-italic text-[0.55em] leading-none ml-px", children: "\u2122" })] }), !short && (
                    // Subordinate to "TrueCare" — sized relative (em) so it scales with the
                    // wordmark at every `size` instead of competing at the full heading size.
                    _jsx("span", { className: "font-body text-[0.62em] font-medium uppercase tracking-wide text-current opacity-80", children: "Partners" }))] })] }));
}
//# sourceMappingURL=Brand.js.map